<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Gib Doküman Durum Sorgulama</h3>
          </div>
          <div>
           
          </div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Doküman UUID numarası</label>
                    <input type="text"  :class="{ 'is-invalid': $v.documentRequest.uuId.$error }" v-model="documentRequest.uuId" class="form-control m-input" placeholder="Gib Doküman Numarası" />
                  </div>
                </div>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tip</label>

                     <select   
                            v-model="documentRequest.documentType" class="form-control m-input" 
                            placeholder="Tip Seçiniz.">
                            <option
                                v-for="option in documentTypes" 
                                v-bind:value="option.id"
                                v-bind:key="option.description"
                                >{{ option.description }}</option
                              >
                                      </select>

                 </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button type="button" @click="getDocumentStatus()" class="btn m-btn--pill btn-primary">Sorgula</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

          <!--begin::Gib Result-->

<div>
   <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <table
                      class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline"
                      id="m_table_1"
                      role="grid"
                      aria-describedby="m_table_1_info"
                      style="width: 1457px;"
                    >
                      <thead>
                        <tr role="row">
                          <th
                            class="sorting_disabled"
                            tabindex="0"
                            aria-controls="m_table_1"
                            rowspan="1"
                            colspan="2"
                            style="width: 57.5px;"
                            aria-label="Order ID: activate to sort column ascending"
                          >Sonuçlar</th>
                        </tr>
                      </thead>
                      <tr>
                                   <tr>
                        <td colspan="2"> Sorgu
                        </td> 
                                   </tr>                    
                         <tr>

                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Gib Doküman Numarası</label>
                    <label class="form-control m-input">{{documentRequest.uuId}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tip</label>
                    <label class="form-control m-input">{{getTypeDesc(documentRequest.documentType)}}</label>
                  </div>
                </div>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="5"> Cevap
                        </td>
                      </tr>
                      <tr>
                   <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Gib Doküman Numarası</label>
                    <label class="form-control m-input">{{documentResponse.uuId}}</label>
                  </div>
                </div>
                        </td>   
                            <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tip</label>
                    <label class="form-control m-input">{{getTypeDesc(documentResponse.documentType)}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Dosya numarası</label>
                    <label class="form-control m-input">{{documentResponse.number}}</label>
                  </div>
                </div>
                        </td>
                         
                      

                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Dosya Referans Numarası</label>
                    <label class="form-control m-input">{{documentResponse.referenceId}}</label>
                  </div>
                </div>
                        </td>

                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Durum Mesajı</label>
                    <label class="form-control m-input">{{documentResponse.message}}</label>
                  </div>
                </div>
                        </td>

                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Cevap Kodu</label>
                    <label class="form-control m-input">{{documentResponse.responseCode}}</label>
                  </div>
                </div>
                        </td>
                        <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Operasyon Durumu</label>
                    <label class="form-control m-input">{{documentResponse.operationStatus}}</label>
                  </div>
                </div>
                        </td>

                                                <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Tarih</label>
                    <label class="form-control m-input">{{documentResponse.currentDate}}</label>
                  </div>
                </div>
                        </td>
                                                <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>İptal</label>
                    <label class="form-control m-input">{{documentResponse.isCancel?"Evet":"Hayır"}}</label>
                  </div>
                </div>
                        </td>

                          <td>
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Başarılı</label>
                    <label class="form-control m-input">{{documentResponse.isSuccess?"Evet":"Hayır" }}</label>
                  </div>
                </div>
                        </td>
                      </tr>
          </table>
              </div>
                  </div>
                </div>
              </div>
</div>
          <!--end::Gib Result-->

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  
</template>
<script>
import { required } from "vuelidate/lib/validators";
import {_getDocumentStatus } from '../../services/EProcessService'

export default {
created() {
  if(this.$route.query.uuId != null && this.$route.query.documentType != null)
        {
          this.documentRequest.uuId=this.$route.query.uuId;
          this.documentRequest.documentType=this.$route.query.documentType;
              this.getDocument();
        }
},
  data() {
    return {
      documentRequest: {
      "uuId":"",
      "documentType":""
      },
      documentResponse: {
       "isSuccess" :false,
       "number" : "",  
       "uuId": "",
       "referenceId": 0,
       "message":"",
       "responseCode": 0,
       "operationStatus": null,
       "documentType":null,
       "currentDate" : null,
       "isCancel" : null
    },
documentTypes : [
  {
    description: "İrsaliye",
    id: "DESPATCHADVICE"
  },{
        description: "Fatura",
        id: "EINVOICE"},
        {
        description: "E Arşiv",
        id: "EARCHIVE",
  }
],
 operationStatuses:
    [
      {
        description : "Error",
        id: -1},
        {
        description : "Success",
         id: 2,},
        {
          description : "Continue",
         id: 1
        }
    
    ]
    }
  },
    validations: {
    
      documentRequest: {
        uuId: { required },
           documentType: { required }
      }
    
  },
methods: {
  getDocumentStatus:function(){
          this.$v.documentRequest.$touch();
      if (this.$v.documentRequest.$error) return;
          // let loader=this.$loading.show();
    _getDocumentStatus(this.documentRequest).then(response=>{
      // loader.hide();
      if(response.data.isSuccess)
      {
        this.documentResponse = response.data;
      }
    });
  },
  getTypeDesc(typeid)
  {
    if (typeid != null)
    {
    var mytype = this.documentTypes.find(a=> a.id == typeid);
    if (mytype!= null)
    return mytype.description;
  }
  return "";
  },
  
  getStatusDesc(statusId)
  {
    if (statusId != null)
    {
    var myStatus = this.operationStatuses.find(a=> a.id == statusId);
    if (myStatus!= null)
    return myStatus.description;
  }
  return "";
  }
  
}
};
</script>